import { t } from 'i18next';
import { Invoice, KsefState } from 'pages/invoices/invoices.types';
import { InvoiceTab } from 'root/pathnames';
import { InvoiceStatus } from '../filters/filters.types';
import { SortProperties, TableData } from './invoicesTable.types';
import { allocationProgress, invoiceStatus } from './invoiceTable.const';

export const getInvoiceKsefState = (
  invoice: Partial<Pick<Invoice, 'ksefState' | 'ksefNumber'>>,
  activeTab?: InvoiceTab,
): KsefState | null => {
  if (invoice.ksefState) return invoice.ksefState;
  if (activeTab === InvoiceTab.FOREIGN && invoice.ksefNumber) return 'ACCEPTED';
  return null;
};

export const getMarkedInvoiceHint = (row: TableData) => {
  if (row.containsUnrecognizedInvoiceLines)
    return t('unknownInvoiceMsg', { ns: 'invoice' });
  else if (row.containsFailedAllocations)
    return t('allocationFailedMsg', { ns: 'invoice' });
  return '';
};

export const getSortProperties = (isOwn: boolean): SortProperties => ({
  id: 'id',
  code: 'code',
  jobCode: 'createdFrom.code',
  logNumber: 'logNumber',
  client: 'buyerCounterparty.code',
  sellerCounterpartyName: 'sellerCounterparty.code',
  saleDate: 'saleDate',
  issueDate: 'issueDate',
  dueDate: 'dueDate',
  grossValue: 'totals.grossValue',
  displayedStatus: isOwn ? 'paid' : 'status',
  status: '',
  isCorrective: '',
  paid: '',
  deleted: '',
  containsComplainedAllocations: '',
  containsUnrecognizedInvoiceLines: '',
  containsFailedAllocations: '',
  currency: '',
  exportInformation: '',
  publicationDate: '',
  owner: '',
  ksefState: '',
  ksefActions: '',
});

export const getInvoiceDisplayedStatus = (
  invoice: Invoice,
  activeTab?: InvoiceTab,
) => {
  if (activeTab === InvoiceTab.OWN || activeTab === InvoiceTab.ADMINISTRATIVE) {
    return invoice.paid ? invoiceStatus.PAID : invoiceStatus.NOT_PAID;
  }
  if (activeTab === InvoiceTab.FOREIGN || activeTab === InvoiceTab.INTERNAL) {
    if (invoice.requiresCorrection) {
      return allocationProgress.COMPLAINED;
    }
    if (invoice.status === InvoiceStatus.NOT_PUBLISHED) {
      return allocationProgress.INITIAL;
    }
    if (invoice.status === InvoiceStatus.EXPORTED) {
      return allocationProgress.FINALIZED;
    }
    if (invoice.status === InvoiceStatus.PUBLISHED) {
      if (!invoice.fullyAllocated) {
        return allocationProgress.PARTIAL;
      }
      if (!invoice.allocationFinished) {
        return allocationProgress.FULL;
      }
      return allocationProgress.ACCEPTED;
    }
    return allocationProgress.CANCELLED;
  }
  return '';
};
